import { lazy } from "react";
import * as staticConfigs from "../utilities/staticConfigs";

// Routes configuration array
export const privateRoutes = [
  {
    path: staticConfigs.ROUTE_SET_PASSWORD,
    component: lazy(() => import("../components/commons/passwordManagement/SetPassword")),
    exact: true,
    id: 'set-password'
  },
  {
    path: staticConfigs.ROUTE_CHANGE_PASSWORD,
    component: lazy(()=> import("../components/commons/passwordManagement/changePassword")),
    exact: true,
    id: 'change-password'
  },
  {
    path: staticConfigs.ROUTE_MYPROFILE,
    component: lazy(()=> import("../components/mainLayoutComponent/headerComponent/MyProfile")),
    exact: true,
    id: 'my-profile'
  },
  {
    path: staticConfigs.ROUTE_POLICY_TYPE,
    component: lazy(()=> import("../components/dictionaries/policyTypes/PolicyTypesList")),
    exact: true,
    id: 'policy-types'
  },
  {
    path: staticConfigs.ROUTE_PATIENT_TYPE,
    component: lazy(()=> import("../components/dictionaries/patientTypes/PatientTypesList")),
    exact: true,
    id: 'patient-types'
  },
  {
    path: staticConfigs.ROUTE_LANGUAGE_TYPE, 
    component: lazy(()=> import("../components/dictionaries/patientLanguages/PatientLanguage")),
    exact: true,
    id: 'patient-languages'
  },
  {
    path: staticConfigs.ROUTE_PRACTICE_LANGUAGE_TYPE, 
    component: lazy(()=> import("../components/dictionaries/patientLanguages/PatientLanguage")),
    exact: true,
    id: 'patient-languages'
  },
  {
    path: staticConfigs.ROUTE_RELATIONSHIP,
    component: lazy(()=> import("../components/dictionaries/relationShips/RelationshipList")),
    exact: true,
    id: 'relationships'
  },
  {
    path: staticConfigs.ROUTE_SUPER_DICTIONARIES,
    component: lazy(()=> import("../components/dictionaries/dictionariesListAll/dictionariesListAll")),
    exact: true,
    id: 'dictionaries'
  },
  {
    path: "/example",
    component: lazy(()=> import("../components/MyTasksScreen/LabTabs")),
    exact: true,
    id: 'lab-tabs'
  },
  {
    path: staticConfigs.ROUTE_ROLES_AND_PERMISSIONS,
    component: lazy(()=> import("../components/userManagement/rolesAndPermissions/rolesAndPermissions")),
    exact: true,
    id: 'roles-permissions'
  },
  {
    path: staticConfigs.ROUTE_ADMIN_ROLES_AND_PERMISSIONS,
    component: lazy(()=> import("../components/userManagement/rolesAndPermissions/rolesAndPermissions")),
    exact: true,
    id: 'admin-roles-permissions'
  },
  {
    path: staticConfigs.ROUTE_RUN_ELIGIBILITY,
    component: lazy(()=> import("../components/patientManagement/RunEligibility/RunEligibility")),
    exact: true,
    id: 'run-eligibility'
  },
  
  // Dictionary Routes
  {
    path: staticConfigs.ROUTE_PRACTICE_DICTIONARIES,
    component: lazy(()=> import("../components/dictionaries/dictionariesListAll/practiceDictionariesListAll")),
    exact: true,
    id: 'practice-dictionaries'
  },
  {
    path: staticConfigs.ROUTE_PAYER_TYPES, 
    component: lazy(()=> import("../components/dictionaries/payerType/PayersList")),
    exact: true,
    id: 'payers'
  },
  {
    path: staticConfigs.ROUTE_REFERRAL_SOURCES,
    component: lazy(()=> import("../components/dictionaries/referralSources/ReferralList")),
    exact: true,
    id: 'referral-sources'
  },
  {
    path: staticConfigs.ROUTE_PRACTICE_REFERRAL_SOURCES,
    component: lazy(()=> import("../components/dictionaries/referralSources/ReferralList")),
    exact: true,
    id: 'practice-referral-sources'
  },
  {
    path: staticConfigs.ROUTE_TYPE_OF_NOTES,
    component: lazy(()=> import("../components/dictionaries/typeOfNotes/dictTypeOfNotes")),
    exact: true,
    id: 'type-of-notes'
  },
  {
    path: staticConfigs.ROUTE_FACILITY_TYPES,
    component: lazy(()=> import("../components/dictionaries/facilityTypes/FacilityList")),
    exact: true,
    id: 'facility-types'
  },
  {
    path: staticConfigs.ROUTE_PRACTICE_TYPES,
    component: lazy(()=> import("../components/dictionaries/practiceTypes/PracticesList")),
    exact: true,
    id: 'practice-types'
  },
  {
    path: staticConfigs.ROUTE_ASSIGNMENT_BENEFITS, 
    component: lazy(()=> import("../components/dictionaries/assignmentBenefits/BenefitList")),
    exact: true,
    id: 'benefits'
  },
  {
    path: staticConfigs.ROUTE_CLAIM_STATUSES,
    component: lazy(()=> import("../components/dictionaries/claimStatus/ClaimStatusList")),
    exact: true,
    id: 'claim-status'
  },
  {
    path: staticConfigs.ROUTE_PRACTICE_CLAIM_STATUSES,
    component: lazy(()=> import("../components/dictionaries/claimStatus/ClaimStatusList")),
    exact: true,
    id: 'practice-claim-status'
  },
  {
    path: staticConfigs.ROUTE_ACCIDENT_TYPES,
    component: lazy(()=> import("../components/dictionaries/accidentTypes/AccidentList")),
    exact: true,
    id: 'accidents'
  },
  {
    path: staticConfigs.ROUTE_CLAIM_SUB_STATUSES,
    component: lazy(()=> import("../components/dictionaries/claimSubStatus/ClaimSubStatusList")),
    exact: true,
    id: 'claim-sub-status'
  },
  {
    path: staticConfigs.ROUTE_PRACTICE_CLAIM_SUB_STATUSES,
    component: lazy(()=> import("../components/dictionaries/claimSubStatus/ClaimSubStatusList")),
    exact: true,
    id: 'practice-claim-sub-status'
  },
  {
    path: staticConfigs.ROUTE_DOCUMENTATION_METHODS,
    component: lazy(()=> import("../components/dictionaries/documentationMethods/DocumentationMethodList")),
    exact: true,
    id: 'documentation-methods'
  },
  {
    path: staticConfigs.ROUTE_DOCUMENT_TYPES,
    component: lazy(()=> import("../components/dictionaries/documentTypes/DocumentList")),
    exact: true,
    id: 'document-types'
  },
  {
    path: staticConfigs.ROUTE_PRACTICE_DOCUMENT_TYPES,
    component: lazy(()=> import("../components/dictionaries/documentTypes/DocumentList")),
    exact: true,
    id: 'practice-document-types'
  },
  {
    path: staticConfigs.ROUTE_SERVICE_EXCEPTIONS, 
    component: lazy(()=> import("../components/dictionaries/serviceAuthorizationException/ExceptionList")),
    exact: true,
    id: 'exceptions'
  },
  {
    path: staticConfigs.ROUTE_PRACTICE_SERVICE_EXCEPTIONS, 
    component: lazy(()=> import("../components/dictionaries/serviceAuthorizationException/ExceptionList")),
    exact: true,
    id: 'exceptions'
  },
  {
    path: staticConfigs.ROUTE_TRANSPORT_REASONS,
    component: lazy(()=> import("../components/dictionaries/transportReasons/TransportList")),
    exact: true,
    id: 'transport-reasons'
  },
  {
    path: staticConfigs.ROUTE_TRACKING_STATUS_SOURCES,
    component: lazy(()=> import("../components/dictionaries/trackingStatusSources/TrackingStatusList")),
    exact: true,
    id: 'tracking-status'
  },
  {
    path: staticConfigs.ROUTE_APPOINTMENT_STATUSES,
    component: lazy(()=> import("../components/dictionaries/appointmentStatus/AppointmentList")),
    exact: true,
    id: 'appointment-status'
  },
  {
    path: staticConfigs.ROUTE_PRACTICE_APPOINTMENT_STATUSES,
    component: lazy(()=> import("../components/dictionaries/appointmentStatus/AppointmentList")),
    exact: true,
    id: 'practice-appointment-status'
  },
  {
    path: staticConfigs.ROUTE_APPOINTMENT_TYPES,
    component: lazy(()=> import("../components/dictionaries/appointmentType/AppointmentTypesList")),
    exact: true,
    id: 'appointment-types'
  },
  {
    path: staticConfigs.ROUTE_PRACTICE_APPOINTMENT_TYPES,
    component: lazy(()=> import("../components/dictionaries/appointmentType/AppointmentTypesList")),
    exact: true,
    id: 'practice-appointment-types'
  },
  {
    path: staticConfigs.ROUTE_PRACTICE_FINANCIAL_CLASSESS,
    component: lazy(()=> import("../components/dictionaries/financialClass/FinancialClassList")),
    exact: true,
    id: 'practice-financial-class'
  },
  {
    path: staticConfigs.ROUTE_FINANCIAL_CLASSESS,
    component: lazy(()=> import("../components/dictionaries/financialClass/FinancialClassList")),
    exact: true,
    id: 'financial-class'
  },
  {
    path: staticConfigs.ROUTE_PRACTICE_PAYER_CLASSESS,
    component: lazy(()=> import("../components/dictionaries/payerClass/PayerClassList")),
    exact: true,
    id: 'practice-payer-class'
  },
  {
    path: staticConfigs.ROUTE_PAYER_CLASSESS,
    component: lazy(()=> import("../components/dictionaries/payerClass/PayerClassList")),
    exact: true,
    id: 'payer-class'
  },
  {
    path: staticConfigs.ROUTE_REVENUE_CODE,
    component: lazy(()=> import("../components/dictionaries/revenueCode/revenueCode")),
    exact: true,
    id: 'revenue-code'
  },
  {
    path: staticConfigs.ROUTE_REMITTANCE_REMARK_CODE, 
    component: lazy(()=> import("../components/dictionaries/remittanceRemarkCode/remittanceRemarkCode")),
    exact: true,
    id: 'remittance-remark'
  },
  {
    path: staticConfigs.ROUTE_PRACTICE_REMITTANCE_REMARK_CODE, 
    component: lazy(()=> import("../components/dictionaries/remittanceRemarkCode/remittanceRemarkCode")),
    exact: true,
    id: 'remittance-remark'
  },
  {
    path: staticConfigs.ROUTE_PRACTICE_ADJUSTMENT_REASON_CODE, 
    component: lazy(()=> import("../components/dictionaries/adjustmentReasonCode/adjustmentReasonCode")),
    exact: true,
    id: 'adjustment-reason'
  },
  {
    path: staticConfigs.ROUTE_ADJUSTMENT_REASON_CODE,  
    component: lazy(()=> import("../components/dictionaries/adjustmentReasonCode/adjustmentReasonCode")),
    exact: true,
    id: 'adjustment-reason'
  },
  {
    path: staticConfigs.ROUTE_CLAIM_FREQUENCY,
    component: lazy(()=> import("../components/dictionaries/claimFrequency/claimFrequency")),
    exact: true,
    id: 'claim-frequency'
  },
  {
    path: staticConfigs.ROUTE_SERVICE_TYPES,
    component: lazy(()=> import("../components/dictionaries/serviceTypes/ServiceTypesList")),
    exact: true,
    id: 'service-types'
  },
  {
    path: staticConfigs.ROUTE_DELAY_REASON_CODE, 
    component: lazy(()=> import("../components/dictionaries/delayReasonCode/delayReasonCode")),
    exact: true,
    id: 'delay-reason'
  },
  {
    path: staticConfigs.ROUTE_PAYMENT_ADJUSTMENT_TYPE, 
    component: lazy(()=> import("../components/dictionaries/paymentAdjustmentType/paymentAdjustmentType")),
    exact: true,
    id: 'payment-adjustment'
  },
  {
    path: staticConfigs.ROUTE_INSURANCE_COMPANIES,
    component: lazy(()=> import("../components/dictionaries/InsuranceCompanies/InsuranceCompanies")),
    exact: true,
    // id: 'insurance-companies'
  },
  {
    path: staticConfigs.ROUTE_TAXONOMIES,
    component: lazy(()=> import("../components/dictionaries/taxonomies/taxonomies")),
    exact: true,
    id: 'taxonomies'
  },
  {
    path: staticConfigs.ROUTE_PRACTICE_CPT_CODES,
    component: lazy(()=> import("../components/dictionaries/CPTCodes/cptcodes")),
    exact: true,
    id: 'practice-cpt-codes'
  },
  {
    path: staticConfigs.ROUTE_CPT_CODES,
    component: lazy(()=> import("../components/dictionaries/CPTCodes/cptcodes")),
    exact: true,
    id: 'cpt-codes'
  },
  {
    path: staticConfigs.ROUTE_PRACTICE_ICD10,
    component: lazy(()=> import("../components/dictionaries/ICD10/icd10")),
    exact: true,
    id: 'practice-icd10'
  },
  {
    path: staticConfigs.ROUTE_ICD10,
    component: lazy(()=> import("../components/dictionaries/ICD10/icd10")),
    exact: true,
    id: 'icd10'
  },
  {
    path: staticConfigs.ROUTE_POS_CODES,
    component: lazy(()=> import("../components/dictionaries/posCodes/POSCodesList")),
    exact: true,
    id: 'pos-codes'
  },
  {
    path: staticConfigs.ROUTE_MODIFIERS,
    component: lazy(()=> import("../components/dictionaries/modifiers/ModifiersList")),
    exact: true,
    id: 'modifiers'
  },
  {
    path: staticConfigs.ROUTE_PAYMENT_SOURCE,
    component: lazy(()=> import("../components/dictionaries/paymentSource/PaymentSource")),
    exact: true,
    id: 'payment-source'
  },
  {
    path: staticConfigs.ROUTE_AR_ACTION_CODE,
    component: lazy(()=> import("../components/dictionaries/ARactionCode/ARactionCodeList")),
    exact: true,
    id: 'ar-action-code'
  },
  {
    path: staticConfigs.ROUTE_PRACTICE_AR_ACTION_CODE,
    component: lazy(()=> import("../components/dictionaries/ARactionCode/ARactionCodeList")),
    exact: true,
    id: 'practice-ar-action-code'
  },
  {
    path: staticConfigs.ROUTE_AR_STATUS,
    component: lazy(()=> import("../components/dictionaries/ARStatus/ARStatus")),
    exact: true,
    id: 'ar-status'
  },
  {
    path: staticConfigs.ROUTE_PRACTICE_AR_STATUS,
    component: lazy(()=> import("../components/dictionaries/ARStatus/ARStatus")),
    exact: true,
    id: 'practice-ar-status'
  },
  {
    path: staticConfigs.ROUTE_PRACTICE_CHARGE_PANELS, 
    component: lazy(()=> import("../components/dictionaries/ChargePanels/ChargePanels")),
    exact: true,
    id: 'charge-panels'
  },
  {
    path: staticConfigs.ROUTE_PRACTICE_CHARGE_PANELS_EDIT, 
    component: lazy(()=> import("../components/dictionaries/ChargePanels/PanelEditor")),
    exact: true,
    id: 'panel-editor'
  },
  {
    path: staticConfigs.ROUTE_TRACKING_STATUS_TYPES,
    component: lazy(()=> import("../components/dictionaries/trackingStatusTypes/TrackingStatusTypesList")),
    exact: true,
    id: 'tracking-status-types'
  },

  // User Management Routes
  {
    path: staticConfigs.ROUTE_ASSOCIATE_USERS,
    component: lazy(()=> import("../components/userManagement/associateUsers/AssociateUsersList")),
    exact: true,
    id: 'associate-users'
  },
  {
    path: staticConfigs.ROUTE_PRACTICE_ASSOCIATE_USERS,
    component: lazy(()=> import("../components/userManagement/associateUsers/AssociateUsersList")),
    exact: true,
    id: 'practice-associate-users'
  },
  {
    path: staticConfigs.ROUTE_ASSOCIATE_USERS_EDIT,
    component: lazy(()=> import("../components/userManagement/associateUsers/AssociateUsersEdit")),
    exact: true,
    id: 'associate-users-edit'
  },
  {
    path: staticConfigs.ROUTE_PRACTICE_ASSOCIATE_USERS_ADD,  
    component: lazy(()=> import("../components/userManagement/associateUsers/associateUserAdd")),
    exact: true,
    id: 'practice-associate-user-add'
  },
  {
    path: staticConfigs.ROUTE_ASSOCIATE_USERS_ADD,
    component: lazy(()=> import("../components/userManagement/associateUsers/associateUserAdd")),
    exact: true,
    id: 'associate-user-add'
  },
  {
    path: staticConfigs.ROUTE_CUSTOMER_PROFILE,
    component: lazy(()=> import("../components/userManagement/customerProfile/CustomerProfileList")),
    exact: true,
    id: 'customer-profile'
  },
  {
    path: staticConfigs.ROUTE_PRACTICES,
    component: lazy(()=> import("../components/userManagement/practices/practices")),
    exact: true,
    id: 'practices'
  },
  {
    path: staticConfigs.ROUTE_PRACTICES_ADD,
    component: lazy(() => import("../components/userManagement/practices/practices-add")),
    exact: true,
    id: 'practices-add'
  },
  {
    path: staticConfigs.ROUTE_PRACTICES_EDIT,
    component: lazy(() => import("../components/userManagement/practices/practices-add")),
    exact: true,
    id: 'practices-edit'
  },
  {
    path: staticConfigs.ROUTE_FACILITIES,
    component: lazy(()=> import("../components/userManagement/facilities/FacilitiesList")),
    exact: true,
    id: 'facilities'
  },
  {
    path: staticConfigs.ROUTE_FACILITIES_ADD,
    component: lazy(() =>import("../components/userManagement/facilities/FacilityAdd").then(module => ({default: module.FacilityAdd}))),
    exact: true,
    id: 'facilities-add'
  },
  {
    path: staticConfigs.ROUTE_FACILITIES_EDIT,
    component: lazy(() =>import("../components/userManagement/facilities/FacilityAdd").then(module => ({default: module.FacilityAdd}))),
    exact: true,
    id: 'facilities-edit'
  },
  {
    path: staticConfigs.ROUTE_PROVIDER_MANAGEMENT,
    component: lazy(()=> import("../components/customerSetup/providerManagement/providerManagement")),
    exact: true,
    id: 'provider-management'
  },
  {
    path: staticConfigs.ROUTE_PROVIDER_ADD,
    component: lazy(()=> import("../components/customerSetup/providerManagement/providerAdd")),
    exact: true,
    id: 'provider-add'
  },
  {
    path: staticConfigs.ROUTE_PROVIDER_EDIT,
    component: lazy(()=> import("../components/customerSetup/providerManagement/providerAdd")),
    exact: true,
    id: 'provider-edit'
  },
  {
    path: staticConfigs.ROUTE_REFERRING_PROVIDER_GROUP,
    component: lazy(()=> import("../components/dictionaries/referringProviderGroup/referringProviderGroup")),
    exact: true,
    id: 'referring-provider-group'
  },
  {
    path: staticConfigs.ROUTE_PRACTICE_REFERRING_PROVIDER_GROUP,
    component: lazy(()=> import("../components/dictionaries/referringProviderGroup/referringProviderGroup")),
    exact: true,
    id: 'practice-referring-provider-group'
  },
  {
    path: staticConfigs.ROUTE_REFERRING_PROVIDER,
    component: lazy(()=> import("../components/userManagement/referringProvider/ReferringProviderList")),
    exact: true,
    id: 'referring-provider'
  },
  {
    path: staticConfigs.ROUTE_REFERRING_PROVIDER_ADD,
    component: lazy(() => import("../components/userManagement/referringProvider/ReferringProviderAdd").then(module => ({default: module.ReferringProviderAdd}))),
    exact: true,
    id: 'referring-provider-add'
  },
  {
    path: staticConfigs.ROUTE_REFERRING_PROVIDER_EDIT,
    component: lazy(() => import("../components/userManagement/referringProvider/ReferringProviderAdd").then(module => ({default: module.ReferringProviderAdd}))),
    exact: true,
    id: 'referring-provider-edit'
  },
  {
    path: staticConfigs.ROUTE_USER_INSURANCE_COMPANIES,
    component: lazy(()=> import("../components/dictionaries/InsuranceCompanies/InsuranceCompanies")),
    exact: true,
    // id: 'insurance-companies'
  },
  {
    path: staticConfigs.ROUTE_USER_INSURANCE_COMPANIES_ADD,
    component: lazy(() =>import("../components/dictionaries/InsuranceCompanies/InsuranceCompanyAdd").then(module => ({default: module.InsuranceCompanyAdd}))),
    exact: true,
    id: 'insurance-companies-add'
  },
  {
    path: staticConfigs.ROUTE_USER_INSURANCE_COMPANIES_EDIT,
    component: lazy(() =>import("../components/dictionaries/InsuranceCompanies/InsuranceCompanyAdd").then(module => ({default: module.InsuranceCompanyAdd}))),
    exact: true,
    id: 'insurance-companies-edit'
  },
  {
    path: staticConfigs.ROUTE_PAGE_LOCKS,
    component: lazy(()=> import("../components/userManagement/pageLocks/pageLocks")),
    exact: true,
    id: 'page-locks'
  },
  {
    path: staticConfigs.ROUTE_USER_ACTION_LOGS,
    component: lazy(()=> import("../components/userActionLogs/UserActionLogs")),
    exact: true,
    id: 'user-action-logs'
  },
  {
    path: staticConfigs.ROUTE_CLAIM_ACTION_LOGS,
    component: lazy(()=> import("../components/userActionLogs/UserActionLogs")),
    exact: true,
    id: 'claim-action-logs'
  },
  {
    path: staticConfigs.ROUTE_CSVTEMPLATES,
    component: lazy(() => import("../components/dictionaries/csvTemplates/CSVTemplates").then(module => ({default: module.CSVTemplates}))),
    exact: true,
    id: 'csv-template'
  },


//   // Patient Management Routes
  {
    path: staticConfigs.ROUTE_PATIENTS_LIST,
    component: lazy(()=> import("../components/patientManagement/patients/PatientLists/patientsList")),
    exact: true,
    id: 'patients-list'
  },
  {
    path: staticConfigs.ROUTE_PATIENT_ADD,
    component: lazy(()=> import("../components/patientManagement/patients/PatientsAdd")),
    exact: true,
    id: 'patient-add'
  },
  {
    path: staticConfigs.ROUTE_PATIENTS_LEDGER_LIST,
    component: lazy(()=> import("../components/patientManagement/patientLedgerList/patientLedgerList")),
    exact: true,
    id: 'patients-ledger-list'
  },
  {
    path: staticConfigs.ROUTE_PATIENTS_LEDGER,
    component: lazy(()=> import("../components/patientManagement/patientLedger/patientLedger")),
    exact: true,
    id: 'patients-ledger'
  },
  {
    path: staticConfigs.ROUTE_STATEMENT_MANAGEMENT,
    component: lazy(()=> import("../components/patientManagement/StatementManagement/StatementManagement")),
    exact: true,
    id: 'statement-management'
  },
  {
    path: staticConfigs.ROUTE_PAYMENT_PLAN, 
    component: lazy(()=> import("../components/patientManagement/PaymentPlan/PaymentPlans")),
    exact: true,
    id: 'payment-plans'
  },
  {
    path: staticConfigs.ROUTE_ACTIVE_PAYMENT_PLAN, 
    component: lazy(()=> import("../components/patientManagement/PaymentPlan/ActivePayment")),
    exact: true,
    id: 'active-payment'
  },
  {
    path: staticConfigs.ROUTE_PATIENT_LETTERS,
    component: lazy(() => import("../components/patientManagement/PatientLetters/PatientLetters")),
    exact: true,
    id: 'patient-letters'
  },

  // Claims Management Routes
  {
    path: staticConfigs.ROUTE_SEARCH_CLAIMS, 
    component: lazy(()=> import("../components/ClaimModule/ClaimModule")),
    exact: true,
    id: 'search-claim'
  },
  {
    path: staticConfigs.ROUTE_BACKGROUND_TASK_LOGS, 
    component: lazy(()=> import("../components/userActionLogs/UserActionLogs")),
    exact: true,
    id: 'batch-status'
  },

  // Customer Setup Routes
  {
    path: staticConfigs.ROUTE_FEE_SCHEDULE_MANAGEMENT, 
    component: lazy(()=> import("../components/customerSetup/feeScheduleManagement/feeScheduleManagement")),
    exact: true,
    id: 'fee-schedule'
  },
  {
    path: staticConfigs.ROUTE_STANDARD_FEE_SCHEDULE_MANAGEMENT, 
    component: lazy(()=> import("../components/customerSetup/feeScheduleManagement/standardFeeSchedule")),
    exact: true,
    id: 'standard-fee-schedule'
  },
  {
    path: staticConfigs.ROUTE_CODE_MANAGEMENT, 
    component: lazy(()=> import("../components/customerSetup/codeManagement/practiceCodeManagement")),
    exact: true,
    id: 'practice-codes'
  },

  // Inbox & Messaging Routes
  {
    path: staticConfigs.ROUTE_COMPOSE_MESSAGES, 
    component: lazy(()=> import("../components/InboxScreens/ComposeScreen")),
    exact: true,
    id: 'compose-message'
  },
  {
    path: staticConfigs.ROUTE_INBOX, 
    component: lazy(() =>import("../components/InboxScreens/inbox").then(module => ({default: module.Inbox}))),
    exact: true,
    id: 'inbox'
  },
  {
    path: staticConfigs.ROUTE_INBOX_MESSAGES, 
    component: lazy(()=> import("../components/InboxScreens/InboxMessageScreen")),
    exact: true,
    id: 'inbox-message'
  },
  {
    path: staticConfigs.ROUTE_REPLY_MESSAGES, 
    component: lazy(()=> import("../components/InboxScreens/ComposeScreen")),
    exact: true,
    id: 'compose'
  },
  {
    path: staticConfigs.ROUTE_SEND_INBOX,
    component: lazy(() => import("../components/InboxScreens/SendMessagesList").then(module => ({default: module.SendMessagesList}))),
    exact: true,
    id: 'send-message-list'
  },
  {
    path: staticConfigs.ROUTE_SEND_INBOX_MESSAGES, 
    component: lazy(()=> import("../components/InboxScreens/SendMessageScreen")),
    exact: true,
    id: 'send-message'
  },
  {
    path: staticConfigs.ROUTE_DRAFT_INBOX, 
    component: lazy(()=> import("../components/InboxScreens/DraftList")),
    exact: true,
    id: 'draft-list'
  },
  {
    path: staticConfigs.ROUTE_DRAFT_INBOX_MESSAGES, 
    component: lazy(()=> import("../components/InboxScreens/DraftMessage")),
    exact: true,
    id: 'draft-message'
  },
  {
    path: staticConfigs.ROUTE_TEMPLATE,
    component: lazy(()=> import("../components/InboxScreens/Template")),
    exact: true,
    id: 'template'
  },
  {
    path: staticConfigs.ROUTE_ADD_TEMPLATE,
    component: lazy(()=> import("../components/InboxScreens/AddTemplate")),
    exact: true,
    id: 'add-template'
  },

  // Task Management Routes
  {
    path: staticConfigs.ROUTE_MY_TASKS, 
    component: lazy(()=> import("../components/MyTasksScreen/Tasks")),
    exact: true,
    id: 'tasks'
  },
  {
    path: staticConfigs.ROUTE_MY_TASKS_EDIT, 
    component: lazy(()=> import("../components/MyTasksScreen/Tasks")),
    exact: true,
    id: 'tasks'
  },
  {
    path: staticConfigs.ROUTE_MY_TASKS_LIST, 
    component: lazy(()=> import("../components/MyTasksScreen/TaskList")),
    exact: true,
    id: 'task-list'
  },

  // Payment Routes
  {
    path: staticConfigs.ROUTE_POST_PAYMENTS,
    component: lazy(()=> import("../components/Payments/PaymentModule/PostPayment")),
    exact: true,
    id: 'post-payment'
  },
  {
    path: staticConfigs.ROUTE_VIEW_PAYMENTS,
    component: lazy(()=> import("../components/Payments/PaymentModule/ViewPayments")),
    exact: true,
    id: 'view-payments'
  },
  {
    path: staticConfigs.ROUTE_ERA_POSTING,
    component: lazy(() => import("../components/Payments/ERAModule/ERAPosting/ERAPosting")),
    exact: true,
    id: 'era-posting'
  },
  {
    path: staticConfigs.ROUTE_PRINT_CONFIG,
    component: lazy(() => import("../components/PrintConfig/PrintConfig")),
    exact: true,
    id: 'system-config'
  },
  {
    path: staticConfigs.ROUTE_AUTOMATION_CONFIG,
    component: lazy(() => import("../components/AutomationConfig/AutomationConfig")),
    exact: true,
    id: 'automation-config'
  },


  // Reports Route
  {
    path: staticConfigs.ROUTE_REPORT_GENERATOR,
    component: lazy(()=> import("../components/reports/ReportGenerator/ReportGenerator")),
    exact: true,
    id: 'report-generator'
  },

   {
    path: staticConfigs.ROUTE_INTERFACE,
    component: lazy(()=> import("../components/Interface/Interface")),
    exact: true,
    id: 'interface'
  },
  {
    path: staticConfigs.ROUTE_WORK_FLOW,
    component: lazy(() => import("../components/Workflow/WorkflowManagement")),
    exact: true,
    id: 'work-flow'
  },
  {
    path: staticConfigs.CLAIM_BETA_SEARCH_CLAIM,
    component: lazy(() => import("../components/ClaimBeta/Claim/SearchClaimsTableComponent")),
    exact: true,
    id: 'claim-beta-search-claims'
  },
  {
    path: staticConfigs.CLAIM_BETA_VIEW_CLAIM,
    component: lazy(() => import("../components/ClaimBeta/Claim/ClaimModule")),
    exact: true,
    id: 'claim-beta-search-claims-view'
  },
  {
    path: staticConfigs.ROUTE_MY_WORK,
    component: lazy(() => import("../components/ClaimBeta/MyWork/MyWork")),
    exact: true,
    id: 'my-work'
  },

  // Add a catch-all route for 404
  {
    path: '*',
    component: lazy(()=> import("../components/commons/notfoundComponent")),
    exact: false,
    id: 'not-found'
  }
  
];